/* eslint-disable indent */
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import classNames from 'classnames'
import randomcolor from 'randomcolor'

// eslint-disable-next-line import/no-unresolved
import Badge from '@mui/material/Badge'
// eslint-disable-next-line import/no-unresolved
import MailOutlineIcon from '@mui/icons-material/MailOutline'
// eslint-disable-next-line import/no-unresolved
import { Tabs } from '@mui/material'

import { Tab, CircularProgress, Switch } from '@material-ui/core'

import Notifier from '../Notifier'
import AlertLabel from './AlertLabel'
import {
    getInbox,
    getHistoricalDialogue,
    getStatuses,
    getDialogueGeneralInfo,
    getAdf,
    getTabCount,
    getSettings,
    getStopBotEvents,
} from '../actions'

import './index.scss'

const autoFilterConfig = [
    {
        id: 'all',
        title: 'All',
    },
    {
        id: 'follow-up',
        title: 'Follow Up',
    },
    {
        id: 'auto-initial',
        title: 'Processed Initial',
    },
    {
        id: 'auto-reply',
        title: 'Processed Reply',
    },
]

const testingConfig = [
    {
        id: 'inbox',
        title: 'inbox',
    },
    {
        id: 'testing_done',
        title: 'done',
    },
    {
        id: 'pending',
        title: 'pending',
    },
]

class Sidebar extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            datepickerDate: [new Date(), new Date()],
            inboxType: 'inbox',
            filterLiveLeads: true,
            autoFilterType: 'all',
            testingFilterType: 'inbox',
        }

        this.listRef = React.createRef()
    }

    componentDidMount() {
        // set Interval
        this.interval = setInterval(() => this.refetch(), 1800000)
    }

    componentWillUnmount() {
        // Clear the interval right before component unmount
        clearInterval(this.interval)
    }

    refetch() {
        const { inboxType: type } = this.state
        const {
            start, end, userSearchString, accountIdParam
        } = this.props
        const searchString = userSearchString === 'NOT_SET' ? '' : userSearchString

        if (type === 'inbox') {
            this.props.getInbox({
                type,
                start,
                end,
                searchString,
                refresh: true,
                accountIdParam,
            })
        }

        this.props.getTabCount({ type: 'pending', start, end })
    }

    componentDidUpdate(oldProps, oldState) {
        const { inboxType: type } = this.state
        const {
            start, end, userSearchString, accountIdParam
        } = this.props

        let shouldUpdate = false

        const searchString = userSearchString === 'NOT_SET' ? '' : userSearchString

        if (
            start
            && end
            && (oldProps.start !== start || oldProps.end !== end)
        ) {
            shouldUpdate = true
        }

        if (
            userSearchString !== 'NOT_SET'
            && oldProps.userSearchString !== searchString
        ) {
            shouldUpdate = true
        }

        if (oldProps.accountIdParam !== this.props.accountIdParam) {
            shouldUpdate = true
            if (this.props.accountIdParam) {
                this.props.getInbox({ accountIdParam })
                const inboxType = 'Search Results'
                this.setState({ inboxType })
                return
            }
        }

        if (oldState.testingFilterType !== this.state.testingFilterType) {
            shouldUpdate = true
        }

        if (oldState.inboxType !== type && type !== 'Search Results') {
            const activeKey = null
            // Clear activeDialog
            this.setState({ activeKey })

            // Notify, that user do not have selected dialogues
            this.props.dispatchSelectedDialogue(activeKey)

            shouldUpdate = true
        }
        const { hash } = this.props.history.location
        const subHash = hash.substring(1)

        if (shouldUpdate) {
            console.log('[SIDEBAR UPDATE]')
            if (subHash) {
                this.props.getInbox({ conversationId: subHash })
            } else if (type !== 'testing') {
                this.props.getInbox({
                    type,
                    start,
                    end,
                    searchString,
                })
            } else {
                const { testingFilterType } = this.state
                const fromTestPage = true
                this.props.getInbox({
                    type: testingFilterType,
                    start,
                    end,
                    searchString,
                    fromTestPage,
                })
            }

            this.props.getTabCount({ type: 'pending', start, end })

            let inboxType = type === 'Search Results' ? 'inbox' : type

            if (searchString) {
                inboxType = 'Search Results'
            }

            this.setState({ inboxType })
        }
        // const { inboxData: threads, location } = this.props
        // const path = location.pathname
        // const id = path.substring(1)
        // if (threads && threads.threads && threads.threads.length > 0) {
        //     const { threads: thread } = threads
        //     for (let i = 0; i < thread.length; i += 1) {
        //         if (thread[i].conversationId === id) {
        //             this.setActiveDialogue(thread[i], i)
        //         }
        //     }
        // }

        this.newThreadsChecker(this.props)
    }

    newThreadsChecker(props) {
        const { triggerInfo } = props
        const { triggerId } = this.state

        if (!triggerInfo) {
            return
        }

        const { id, key } = triggerInfo

        if (!id || id === triggerId) {
            return
        }

        // if (initiator !== 'human') {
        //  return
        // }

        this.setState({ triggerId: id, triggerKey: key })
    }

    setActiveDialogue(dialogue, index) {
        const { dialogueHandlers } = this.props

        const activeKey = `${dialogue.account}/${dialogue.conversationId}`
        console.log('activeKey', activeKey)

        if (activeKey in dialogueHandlers) {
            console.log('Hey jo, stop!')
            return
        }

        let { activeKey: currentActiveKey } = this.state

        if (currentActiveKey) {
            const splitted = currentActiveKey.split('/')
            const [account, conversationId] = splitted

            currentActiveKey = `${account}/${conversationId}`

            if (activeKey === currentActiveKey) {
                return
            }
        }

        this.setState({ activeKey: `${activeKey}/${index}` }, () => {
            // this will become the main source of info
            this.props.getDialogueGeneralInfo(dialogue)

            // adf
            this.props.getAdf(dialogue)

            this.props.getHistoricalDialogue(dialogue)
            this.props.getStopBotEvents(dialogue)
            this.props.getStatuses(dialogue)
            this.props.dispatchSelectedDialogue(activeKey)
            this.props.getSettings(dialogue.account)
        })
        // this.props.history.push(`/${dialogue.conversationId}`)
    }

    onScrollHander() {
        const container = this.listRef.current
        const { loadingInbox, inboxData } = this.props

        if (loadingInbox || !inboxData) {
            return
        }

        if (!inboxData.lastKey) {
            return
        }

        if (
            container.offsetHeight + container.scrollTop
            >= container.scrollHeight
        ) {
            const { inboxType: type } = this.state
            const { start, end } = this.props

            const startKey = inboxData.lastKey
            const accumulate = true

            if (type !== 'testing') {
                this.props.getInbox({
                    type,
                    start,
                    end,
                    startKey,
                    accumulate,
                })
            } else {
                const { testingFilterType } = this.state
                const fromTestPage = true
                this.props.getInbox({
                    testingFilterType,
                    start,
                    end,
                    startKey,
                    accumulate,
                    fromTestPage,
                })
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    filterThreads(threads, filterType) {
        let results = []
        switch (filterType) {
            case 'all':
                results = threads
                break
            case 'follow-up':
                results = threads.filter(thread => thread.followUp)
                break
            case 'auto-initial':
                results = threads.filter(
                    thread => !thread.followUp && thread.interaction === 1
                )
                break
            case 'auto-reply':
                results = threads.filter(
                    thread => !thread.followUp && thread.interaction > 1
                )
                break
            default:
                results = threads
                break
        }
        return results
    }

    handleCopyAccount (accountValue) {
      if (navigator.clipboard && accountValue) {
        navigator.clipboard.writeText(accountValue)
          .then(() => {
            console.log('Account copied to clipboard:', accountValue);
          })
          .catch(err => {
            console.error('Failed to copy account:', err);
          });
      } else {
        console.warn('Clipboard API not available or account value is empty.');
      }
    }

    render() {
        const { dialogueHandlers, loadingInbox } = this.props
        const inboxData = { ...this.props.inboxData }

        if (
            this.state.inboxType === 'pending'
            && inboxData
            && 'threads' in inboxData
        ) {
            const threads = [...inboxData.threads]
            if (this.state.filterLiveLeads) {
                inboxData.threads = threads.filter(
                    thread => !(
                        'accountIsLive' in thread
                            && thread.accountIsLive === false
                    )
                )
            } else {
                inboxData.threads = threads.filter(
                    thread => 'accountIsLive' in thread
                        && thread.accountIsLive === false
                )
            }
        }

        if (
            this.state.inboxType === 'auto'
            && inboxData
            && 'threads' in inboxData
            && this.state.autoFilterType
        ) {
            inboxData.threads = this.filterThreads(
                [...inboxData.threads],
                this.state.autoFilterType
            )
        }

        const { hash } = this.props.history.location
        const subHash = hash.substring(1)

        const { activeKey, triggerId, triggerKey } = this.state
        const listItemClassNames = (
            { insertedFromRedux, stopped },
            currentKey
        ) => classNames({
            'active-block': activeKey === currentKey,
            animated: insertedFromRedux,
            inactive: stopped,
        })

        const renderDialogues = inboxData
            && inboxData.threads
            && inboxData.threads.map((dialog, index) => (
                <li
                    key={index}
                    className={listItemClassNames(
                        dialog,
                        `${dialog.account}/${dialog.conversationId}/${index}`
                    )}
                    onClick={() => this.setActiveDialogue(dialog, index)}
                >
                    <div className='block'>
                        <p>
                            {dialog.user} / {dialog.channel}
                            {dialogueHandlers[
                                `${dialog.account}/${dialog.conversationId}`
                            ]
                                // && activeKey === `${dialog.account}/${dialog.user}/${dialog.conversationId}/${index}`
                                // && activeKey === `${dialog.account}/${dialog.user}/${dialog.thread}/${index}`
                                && dialogueHandlers[
                                    `${dialog.account}/${dialog.conversationId}`
                                ].map((i, idx) => (
                                    <b key={i + idx + 'un'}>&nbsp; / {i}</b>
                                ))}
                        </p>
                        {dialog.source !== '-' && <p>{dialog.source}</p>}

                        <div
                            className='badge dealer-badge'
                            style={{
                                cursor: 'pointer',
                                backgroundColor: randomcolor({
                                    luminosity: 'light',
                                    seed: dialog.account,
                                }),
                            }}
                              onClick={() => this.handleCopyAccount(dialog.account)}
                              title={`Click to copy: ${dialog.account}`}
                        >
                            {dialog.account}
                        </div>
                    </div>
                    <div className='DialogAlert'>
                        {dialogueHandlers[
                            `${dialog.account}/${dialog.conversationId}`
                        ]
                        && dialogueHandlers[
                            `${dialog.account}/${dialog.conversationId}`
                        ].includes(
                            localStorage.getItem(
                                'pulsarBotPlatform_operatorUsername'
                            )
                        )
                        && dialogueHandlers[
                            `${dialog.account}/${dialog.conversationId}`
                        ][0]
                            !== localStorage.getItem(
                                'pulsarBotPlatform_operatorUsername'
                            ) ? (
                                <AlertLabel />
                            ) : null}
                    </div>
                </li>
            ))

        const getMinimalCount = number => {
            if (number > 9) return '9+'
            return number
        }

        const handleAutoFilter = type => {
            console.log(type)
            this.setState({ autoFilterType: type })
        }

        const handleTestingFilter = type => {
            console.log('type is: ', type)
            this.setState({ testingFilterType: type })
        }

        return (
            <div className='OperatorSidebar'>
                <Notifier notificationId={triggerId} leadKey={triggerKey} />

                {this.state.inboxType !== 'Search Results' && !subHash && (
                    <div className='controls'>
                        <Tabs
                            value={this.state.inboxType}
                            onChange={(e, inboxType) => this.setState({ inboxType })
                            }
                            indicatorColor='primary'
                            textColor='primary'
                            variant='scrollable'
                            scrollButtons
                            aria-label='full width tabs'
                            classes={{
                                scroller: 'sidebar-tabs-scroller',
                            }}
                        >
                            <Tab
                                style={{ marginLeft: '5.5rem' }}
                                classes={{ root: 'tab-root' }}
                                label={
                                    <span className='tab-label'>Attention</span>
                                }
                                value='inbox'
                            />
                            {/* <Tab */}
                            {/*    classes={{ root: 'tab-root' }} */}
                            {/*    label={<span className='tab-label'>Done</span>} */}
                            {/*    value='done' */}
                            {/* /> */}
                            <Tab
                                classes={{ root: 'tab-root' }}
                                label={
                                    <span className='tab-label'>Processed</span>
                                }
                                value='auto'
                            />
                            <Tab
                                classes={{ root: 'tab-root' }}
                                label={
                                    <span className='tab-label'>Testing</span>
                                }
                                value='testing'
                            />
                            <Tab
                                classes={{ root: 'tab-root' }}
                                fullWidth={true}
                                label={
                                    <span className='tab-label'>
                                        Pending
                                        {/* {this.props.tabCounts && */}
                                        {/* this.props.tabCounts.pending ? ( */}
                                        {/* <span className="tab-label-count"> */}
                                        {/*   {getMinimalCount( */}
                                        {/*     this.props.tabCounts.pending */}
                                        {/*   )} */}
                                        {/* </span> */}
                                        {/* ) : null} */}
                                        {this.props.tabCounts
                                        && this.props.tabCounts.pending ? (
                                            <Badge badgeContent={getMinimalCount(this.props.tabCounts.pending)}
                                                color='error'>
                                                <MailOutlineIcon />
                                            </Badge>
                                            ) : null}
                                    </span>
                                }
                                value='pending'
                            />
                        </Tabs>
                    </div>
                )}
                {this.state.inboxType === 'pending' ? (
                    <div className='switch-filter'>
                        <p>show live leads</p>
                        <Switch
                            size='small'
                            checked={this.state.filterLiveLeads}
                            onChange={e => {
                                this.setState({
                                    filterLiveLeads: e.target.checked,
                                })
                            }}
                            color='primary'
                            name='checkedB'
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                    </div>
                ) : null}
                {this.state.inboxType === 'testing' ? (
                    <div className='auto-radio-group'>
                        {testingConfig.map(({ id, title }) => (
                            <span
                                key={id}
                                className={
                                    this.state.testingFilterType === id
                                        ? 'auto-radio-item--active'
                                        : 'auto-radio-item'
                                }
                                onClick={() => handleTestingFilter(id)}
                            >
                                {title}
                            </span>
                        ))}
                    </div>
                ) : null}
                {this.state.inboxType === 'auto' ? (
                    <div className='auto-radio-group'>
                        {autoFilterConfig.map(({ id, title }) => (
                            <span
                                key={id}
                                className={
                                    this.state.autoFilterType === id
                                        ? 'auto-radio-item--active'
                                        : 'auto-radio-item'
                                }
                                onClick={() => handleAutoFilter(id)}
                            >
                                {title}
                            </span>
                        ))}
                    </div>
                ) : null}
                <div
                    ref={this.listRef}
                    onScroll={() => this.onScrollHander()}
                    className='scrollable-area'
                >
                    {inboxData && (
                        <React.Fragment>
                            {inboxData.threads && !inboxData.threads.length && (
                                <p className='no-dialogues'>
                                    {this.state.inboxType === 'inbox'
                                        ? 'Nothing here, good job'
                                        : 'No dialogues'}
                                </p>
                            )}

                            <ul>{renderDialogues}</ul>
                        </React.Fragment>
                    )}

                    {loadingInbox ? (
                        <div className='loading-wrapper'>
                            <CircularProgress size={30} />
                        </div>
                    ) : (
                        inboxData
                        && inboxData.lastKey && (
                            <div className='more-button-container'>
                                <div
                                    className='more-button'
                                    onClick={() => this.onScrollHander()}
                                >
                                    <p>load more</p>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const {
        loadingInbox, inboxData, triggerInfo, tabCounts
    } = state.operatorDashboard

    const { start, end } = state.operatorDashboardPeriods

    const { userSearchString = 'NOT_SET' } = state.operatorDashboardUserSearch

    const { accountIdParam = '' } = state.operatorDashboardAccountSelector

    return {
        start,
        end,
        loadingInbox,
        inboxData,
        triggerInfo,
        userSearchString,
        tabCounts,
        accountIdParam,
    }
}

export default withRouter(
    connect(mapStateToProps, {
        getInbox,
        getHistoricalDialogue,
        getStatuses,
        getDialogueGeneralInfo,
        getTabCount,
        getAdf,
        getSettings,
        getStopBotEvents,
    })(Sidebar)
)
